import React, { useContext, useEffect } from 'react'
import { useState } from 'react';
import { env } from '../..';
import { apiFetch } from '../../services'
import Page from './index'
import { DataContext } from '../../app';

const setRefreshState = (loading, setPageState) => setPageState(current => ({
	...current,
	loading,
	reload: false,
	keyCnt: current.keyCnt + (current.reinit && !loading ? 1 : 0),
	reinit: !loading ? false : current.reinit
}))
const onClickReload = (setPageState) => (evt) => {
	if (evt.persist instanceof Function) evt.persist();

	setPageState(current => ({
		...current,
		reload: !!evt.ctrlKey,
		reinit: evt.ctrlKey,
		keyCnt: current.keyCnt + (evt.ctrlKey ? 0 : 1),
		modified: undefined
	}))
}

const setSubscribeState = (subscribed, setPageState) => setPageState(current => ({ ...current, subscribed }))

const subscriptionPolling = (reloadPage, id, modified, currentScope, signal, devenv) =>
	apiFetch(`/exec/pages_get/${id}`, { modified }, currentScope, signal)
		.then(resp => {
			if (resp.page) {
				console.log("page updated from server", resp.page.modified)
				reloadPage(resp.page)
			} else if (resp._response.ok) {
				if (devenv) subscriptionPolling(reloadPage, id, modified, currentScope, signal, devenv)
				else console.log("subscription ended", devenv);
			} else {
				console.log("subscription exception", resp);
			}
		})


export const PageLoader = ({ modified, lazy, loaded, background, ...page }) => {

	const context = useContext(DataContext);

	const dispatch = context.dispatch;
	const currentScope = context.scope?.current
	const { id, title, isInnerPage } = page;
	const [{ loading, reload, subscribed, keyCnt, ...state }, setPageState] = useState({ loading: false, reload: false, subscribed: false, modified, keyCnt: 0 });
	const devenv = env !== "production"
	const pageModified = state.modified && state.modified !== modified
	const pageKeyScoped = `page/scoped/${currentScope.empresa}/${currentScope.tipo}/${currentScope.id}/${id}`

	const reset = context.pageloader?.reset || false

	const { pageBackground } = context

	useEffect(() => {
		if (pageBackground)
			pageBackground(background || "169, 169, 169");
	}, [pageBackground, background])

	//inicializa state.modified cuando el componente se renderiza desde lazy load.
	useEffect(() => {
		if (!state.modified && modified)
			setPageState(current => ({ ...current, modified }))
	}, [modified, state.modified])

	useEffect(() => {
		if (currentScope && (reload || !loaded)) {
			const setPage = resp => {
				dispatch({ type: "set-page", payload: resp.page })
				setRefreshState(false, setPageState)
				return resp.page
			}

			const savedPage = window.localStorage.getItem(pageKeyScoped)
			if (savedPage)
				setPage({ page: JSON.parse(savedPage) })
			else {
				setRefreshState(true, setPageState)
				apiFetch(`/exec/pages_get/${id}`, {}, currentScope)
					.then(setPage)
					.then(page => window.localStorage.setItem(pageKeyScoped, JSON.stringify(page)))
			}
		} else if (loaded) {
			const flag = { current: false }
			const storageChange = evt => { if (evt.key === pageKeyScoped) { flag.current = console.log("storage change") || true } }
			window.addEventListener("storage", storageChange)

			console.log("waiting for changes")

			return () => {
				window.removeEventListener("storage", storageChange)
				if (flag.current) {
					console.log("unsetting page for next reload")
					dispatch({ type: "unset-page", payload: { id } })
				} else {
					console.log("page exit without flag")
				}
			}
		}
	}, [currentScope, dispatch, id, reload, loaded, pageKeyScoped])

	useEffect(() => {
		if (currentScope && !reload && !loading) {
			const fetchController = new AbortController()
			setSubscribeState(true, setPageState)
			console.log("subscribing to server modifications");

			const renewPage = page => {
				if (devenv) dispatch({ type: "set-page", payload: page }) //hot reload
				window.localStorage.setItem(pageKeyScoped, JSON.stringify(page))
				window.dispatchEvent(new StorageEvent("storage", { key: pageKeyScoped }))
				setSubscribeState(false, setPageState)
			}

			subscriptionPolling(renewPage, id, modified, currentScope, fetchController.signal, devenv)
			return () => fetchController.abort();
		} else {
			setSubscribeState(false, setPageState)
		}
	}, [currentScope, dispatch, id, reload, loading, modified, devenv, pageKeyScoped])

	useEffect(() => {
		if (reset) {
			setPageState(current => ({
				...current,
				reload: true,
				reinit: true,
				modified: undefined
			}))
		}
	}, [reset])


	return [
		loaded ? <Page key={`pageloader-content-${id}-${keyCnt}`} context={context} {...page} /> : <p key="pageloader-loading">Cargando {title || 'contenido'}.</p>,
		!isInnerPage && devenv && (
			<div key="pageloader-debug-info" className="bg-secondary mt-auto p-1 d-flex flex-row-reverse align-items-center" style={{ height: "60px" }} >
				<button
					disabled={loading}
					className={`"btn btn-sm ${pageModified ? "btn-info" : "btn-light"} mx-1"`}
					onClick={onClickReload(setPageState)}
				>{loading ? "Cargando" : "Recargar"}</button>
				<span className="px-1" >{subscribed.toString()}</span>
				<span className="px-1" >debug-info</span>
			</div>
		)
	]
}


export default PageLoader;
